import React from "react";
import "./Footer.css";

const Footer = () => {
    return(
        <>
            <div className="footer_container">
                Copyrights Reserved © - 2021-2030 | Privacy and Securities | Terms of Use 
            </div>
        </>
    )
}

export default Footer;